import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { setEditId, selectBundleById } from "../../../store/mine_craft/bundlesSlice";
import { fetchBundle } from "../../../actions/mine_craft/bundlesActions";
import { fetchProducts } from "../../../actions/mine_craft/productsActions";

import PageLayout from "../_partials/PageLayout";
import SummaryShow from "../../../componets/SummaryShow";
import Details from "./_partials/_Details";
import Products from "./_partials/_Products";
import Tabs from "../../../componets/Tabs";
import Edit from "./Edit";
import { ButtonEdit } from "../../../componets/Buttons";
import SidebarShow from "../Bundles/_partials/_SidebarShow";

const Show: React.FC = () => {
  const { id } = useParams();
  const dispatch = useAppDispatch();
  const bundle = useAppSelector(state => id ? selectBundleById(state, id) : undefined);

  useEffect(() => {
    if (id) {
      dispatch(fetchBundle(id));
      dispatch(fetchProducts({ bundle_id: id }));
    }
  }, [id, dispatch]);

  function onClickEdit() {
    if (bundle) {
      dispatch(setEditId(bundle.id));
    }
  }

  return (
    <PageLayout className='v-bundles-show'>
      <div className='v-container-fluid'>
        <div className='o-header'>
          {
            bundle &&
              <SummaryShow
                title={bundle.name}
                createdAt={bundle.created_at}
                updatedAt={bundle.updated_at}
                actions={[
                  <ButtonEdit key='button-edit' onClick={onClickEdit} />
                ]}
                className='v-mb-15'
              />
          }

          <Tabs
            paramsKey='tab'
            destroyInactiveTabPane={true}
            items={[
              { label: 'Details',  key: 'details',  children: <Details bundle={bundle} /> },
              { label: 'Products', key: 'products', children: <Products bundle={bundle} /> }
            ]}
          />
        </div>
      </div>

      <Edit />

      <SidebarShow bundle={bundle} />
    </PageLayout>
  )
}

export default Show;
